export default __webpack_public_path__ + "static/media/IconDesc_NonFissileUranium.256.d71944c2.png";